function faq() {
    let faqList = document.querySelectorAll(".faq-list");
    if (faqList.length > 0) {
        for (let list = 0; list < faqList.length; list++) {
            const faqQuestions =
                faqList[list].querySelectorAll(".faq-question");
            const faqAnswer = faqList[list].querySelectorAll(".faq-answer");
            let answerHeight;
            let marginTop = 38;

            faqQuestions.forEach((question, index) => {
                question.addEventListener("click", function (e) {
                    e.preventDefault();

                    const isActive =
                        question.parentElement.classList.contains("active");

                    faqQuestions.forEach((element) => {
                        element.parentElement.classList.remove("active");
                    });

                    faqAnswer.forEach((el) => {
                        el.style.height = `0px`;
                        el.style.marginTop = `0px`;
                    });

                    answerHeight = faqAnswer[index].scrollHeight;

                    if (isActive) {
                        question.parentElement.classList.remove("active");
                        faqAnswer[index].style.height = `0px`;
                        faqAnswer[index].style.marginTop = `0px`;
                    } else {
                        question.parentElement.classList.add("active");
                        faqAnswer[index].style.height = `${answerHeight}px`;
                        faqAnswer[index].style.marginTop = `${marginTop}px`;
                    }
                });
            });
        }
    }
}
faq();
